import { render, staticRenderFns } from "./AmazeDevelopmentInfo.vue?vue&type=template&id=12a92250"
import script from "./AmazeDevelopmentInfo.vue?vue&type=script&lang=js"
export * from "./AmazeDevelopmentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports